import pluralize, { plural } from 'pluralize';

// eslint-disable-next-line import/prefer-default-export
export const toCamel = s => {
  return s.replace(/([-_][a-z])/gi, $1 => {
    return $1
      .toUpperCase()
      .replace('-', '')
      .replace('_', '');
  });
};

export const toSnake = (s, divider = '_') => {
  return plural(s.replace(/([a-z])([A-Z])/g, `$1${divider}$2`).toLowerCase());
};

export const toSingular = s => {
  return pluralize((s || '').replace(/Grid$/, ''), 1);
};
